import Vue from 'vue'

Vue.filter('mergeProps', (a, b) => {
  if (typeof a === 'string') {
    console.warn('pass in Array or Object to merge props.')
    return
  }

  const props = []

  if (Array.isArray(a)) {
    // props.push([...a])
    a.forEach((x) => {
      if (x) {
        props.push(x)
      }
    })
  } else if (typeof a === 'object' && a.constructor === Object) {
    props.push(a)
  }

  if (Array.isArray(b)) {
    // props.push([...b])
    b.forEach((x) => {
      if (x) {
        props.push(x)
      }
    })
  } else if (typeof b === 'object' && b.constructor === Object) {
    props.push(b)
  }

  return props
})
